document.addEventListener('DOMContentLoaded', () => {
  const style = document.createElement('style');
  style.textContent = `
    .custom-gift-remove-btn {
      transition: opacity 0.2s ease;
    }
    .custom-gift-remove-btn.removing {
      opacity: 0.5;
    }
  `;
  document.head.appendChild(style);

  const observerConfig = { childList: true, subtree: true };

  const callback = function(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.classList.contains('gfgFreeGiftMsgOptionRow')) {
              injectRemoveButton(node);
            } else if (node.querySelectorAll) {
              node.querySelectorAll('.gfgFreeGiftMsgOptionRow').forEach(injectRemoveButton);
            }
          }
        });
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(document.body, observerConfig);

  // Initial pass for any rows already present when the script loads
  document.querySelectorAll('.gfgFreeGiftMsgOptionRow').forEach(injectRemoveButton);
});

function injectRemoveButton(row) {
  if (row.querySelector('.custom-gift-remove-btn')) return;

  const container = row.querySelector('.gfgFreeGiftContainer');
  const claimButton = row.querySelector('.gfgFreeGiftClaimButton');
  const productId = row.getAttribute('product-id');

  if (!container || !claimButton || !productId) return;

  const translations = window.kiteGiftTranslations || { remove: 'Remove', removing: 'Removing...' };

  const removeBtn = document.createElement('div');
  removeBtn.className = 'custom-gift-remove-btn';
  removeBtn.textContent = translations.remove;

  const isClaimed = claimButton.classList.contains('gfgFreeGiftActiveFreeGiftClaimButton');

  removeBtn.style.cssText = `
    display: ${isClaimed ? 'inline-block' : 'none'};
    margin-left: 10px;
    cursor: pointer;
    font-size: 13px;
    text-decoration: underline;
    color: #777;
  `;

  claimButton.addEventListener('click', () => {
    setTimeout(() => {
      if (claimButton.classList.contains('gfgFreeGiftActiveFreeGiftClaimButton')) {
        removeBtn.style.display = 'inline-block';
      }
    }, 1500);
  });

  // Handle remove click
  removeBtn.addEventListener('click', async (e) => {
    e.preventDefault();
    e.stopPropagation();

    removeBtn.textContent = translations.removing;
    removeBtn.classList.add('removing');
    removeBtn.style.pointerEvents = 'none';

    try {
      await removeFromCart(productId);
    } catch (error) {
      console.error('Error removing gift:', error);
      removeBtn.textContent = translations.remove;
      removeBtn.classList.remove('removing');
      removeBtn.style.pointerEvents = 'auto';
    }
  });

  claimButton.parentNode.insertBefore(removeBtn, claimButton.nextSibling);
}

async function removeFromCart(productId) {
  const cartUrl = typeof theme !== 'undefined' && theme.routes ? `${theme.routes.cart}.js` : '/cart.js';
  const cartRes = await fetch(cartUrl);
  if (!cartRes.ok) throw new Error('Failed to fetch cart');

  const cartData = await cartRes.json();
  const productIdNum = Number(productId);
  const itemToRemove = cartData.items.find(item => item.product_id === productIdNum);

  if (!itemToRemove) return;

  const changeUrl = typeof theme !== 'undefined' && theme.routes ? theme.routes.cartChange : '/cart/change.js';
  const updateRes = await fetch(changeUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: itemToRemove.key, quantity: 0 })
  });

  if (!updateRes.ok) throw new Error('Failed to update cart');
}
